module.exports = __webpack_public_path__ + "static/media/EGY.56e79cc3.svg";